// Rapor kartı sihirbazı (Yeni Rapor Kartı / Rapor Kartını Düzenle) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.reportBuilder';

export const reportBuilderGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Rapor kartı nasıl oluşturulur?'),
  intro: t(`${G}.intro`, 'Bu sihirbaz, Yönetici Ekranı\'na kendi rapor kartınızı ekler. Altı adımda veriyi, ölçüyü, gruplamayı, filtreleri ve görünümü seçer, kartı adlandırıp kaydedersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.source`, 'Veri Kaynağı'),
    t(`${G}.nav.metric`, 'Metrik'),
    t(`${G}.nav.dimension`, 'Gruplama'),
    t(`${G}.nav.filters`, 'Filtreler'),
    t(`${G}.nav.visual`, 'Görsel Tip'),
    t(`${G}.nav.preview`, 'Ad + Önizleme'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Adımlar'),
    body: t(`${G}.regions.body`, 'Adım içeriği'),
    footer: t(`${G}.regions.footer`, 'Vazgeç / Geri / İleri / Kaydet'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Adımları sırayla izleyin'),
      text: t(`${G}.s1.text`, 'Üstteki çizgi hangi adımda olduğunuzu gösterir. Yeni kartta pencere "Yeni Rapor Kartı", var olan kartı düzenlerken "Rapor Kartını Düzenle" başlığıyla ve kartın mevcut seçimleriyle açılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Veri kaynağını ve metriği seçin'),
      text: t(`${G}.s2.text`, 'Veri Kaynağı raporun hangi kayıtlardan hesaplanacağını belirler: Hızlı Satış Fişleri, Fiş Ödemeleri, Paket Siparişler, Restoran Satışları, satılan ürünler, Kasa / Banka / Cari Hareketler, Faturalar, Stok Hareketleri, Çek / Senet. Ardından Metrik adımında neyin ölçüleceğini seçin (ör. Toplam Tutar, Fiş Sayısı, Ortalama Sepet, Gelir Toplamı).'),
      tips: [
        t(`${G}.s2.tip1`, 'Kaynağı değiştirirseniz seçili metrik, gruplama ve filtreler sıfırlanır.'),
        t(`${G}.s2.tip2`, 'Çek / Senet kaynağında tarih filtresi vade tarihine uygulanır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Gruplama ve zaman kırılımı'),
      text: t(`${G}.s3.text`, 'Gruplama, sonucu nasıl böleceğinizi seçer: şube, ekran, kasiyer, ödeme tipi, ürün gibi. "Gruplama yok (tek toplam)" tek bir sayı üretir. "Zaman" seçilirse Zaman aralığı olarak Saat, Gün, Haftanın Günü veya Ay seçersiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Gruplama yoksa yalnız Tek Değer (KPI) görünümü seçilebilir.'),
        t(`${G}.s3.tip2`, 'Zaman gruplamasında Çizgi Grafik, Çubuk Grafik veya Tablo; diğer gruplamalarda Çubuk Grafik, Pasta Grafik veya Tablo seçilebilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Filtreleri belirleyin (isteğe bağlı)'),
      text: t(`${G}.s4.text`, 'Kaynağa göre şube, ekran, kasa, banka hesabı, depo, ödeme yöntemi gibi filtreler listelenir; istediğiniz değerleri işaretleyin. Boş bırakılan filtre "hepsi" anlamına gelir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Yönetici Ekranı\'ndaki Şube Filtresi rapor kartlarına uygulanmaz; belirli şubeleri görmek istiyorsanız (kaynakta Şube filtresi varsa) şubeyi burada seçin.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Görünümü seçin, adlandırın ve önizleyin'),
      text: t(`${G}.s5.text`, 'Görsel Tip adımında kartın nasıl çizileceğini seçin: Tek Değer (KPI), Çubuk, Pasta, Çizgi Grafik veya Tablo. Son adımda Kart Adı yazın (zorunlu, en fazla 80 karakter); altta kartın önizlemesi Yönetici Ekranı\'nın o an seçili tarih aralığıyla çizilir.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Kaydedin'),
      text: t(`${G}.s6.text`, '"İleri" o adımda gerekli seçim yapılmadan açılmaz (kaynak, metrik ve kart adı zorunludur). "Geri" önceki adıma döner, "Vazgeç" kaydetmeden kapatır. Son adımdaki "Kaydet" yeni kartı Yönetici Ekranı\'na ekler veya düzenlediğiniz kartı günceller.'),
      tips: [
        t(`${G}.s6.tip1`, 'Rapor kartları bu cihazda (tarayıcıda) saklanır; başka bir bilgisayarda görünmez.'),
        t(`${G}.s6.tip2`, 'Kart, Yönetici Ekranı\'nda seçtiğiniz tarih aralığı değiştikçe kendini yeniden hesaplar.'),
      ],
    },
  ],
});
